import { Editor, Element, Descendant, Text, Transforms } from "slate";
import basicModules from "@wangeditor/basic-modules";
import wangEditorListModule from "@wangeditor/list-module";
// table-module
import wangEditorTableModule from "@wangeditor/table-module";
// video-module
import wangEditorVideoModule from "@wangeditor/video-module";
// upload-image-module
import wangEditorUploadImageModule from "@wangeditor/upload-image-module";
// code-highlight
import { wangEditorCodeHighlightModule } from "@wangeditor/code-highlight";
import markdownModule from "@wangeditor/plugin-md";
import formulaModule from "@wangeditor/plugin-formula";
// import {
//   SlateEditor,
//   SlateTransforms,
//   SlatePoint,
//   SlateNode,
//   DomEditor,
// } from "@wangeditor/editor";
import $, {
  css,
  append,
  addClass,
  removeClass,
  hasClass,
  on,
  focus,
  attr,
  hide,
  show,
  // scrollTop,
  // scrollLeft,
  offset,
  width,
  height,
  parent,
  parents,
  is,
  dataset,
  val,
  text,
  removeAttr,
  children,
  html,
  remove,
  find,
  each,
  empty,
  Dom7Array,
} from "dom7";
export const IGNORE_TAGS = new Set([
  "doctype",
  "!doctype",
  "meta",
  "script",
  "style",
  "link",
  "frame",
  "iframe",
  "title",
  "svg", // TODO 暂时忽略
]);
if (css) $.fn.css = css;
if (append) $.fn.append = append;
if (addClass) $.fn.addClass = addClass;
if (removeClass) $.fn.removeClass = removeClass;
if (hasClass) $.fn.hasClass = hasClass;
if (on) $.fn.on = on;
if (focus) $.fn.focus = focus;
if (attr) $.fn.attr = attr;
if (removeAttr) $.fn.removeAttr = removeAttr;
if (hide) $.fn.hide = hide;
if (show) $.fn.show = show;
// if (scrollTop) $.fn.scrollTop = scrollTop
// if (scrollLeft) $.fn.scrollLeft = scrollLeft
if (offset) $.fn.offset = offset;
if (width) $.fn.width = width;
if (height) $.fn.height = height;
if (parent) $.fn.parent = parent;
if (parents) $.fn.parents = parents;
if (is) $.fn.is = is;
if (dataset) $.fn.dataset = dataset;
if (val) $.fn.val = val;
if (text) $.fn.text = text;
if (html) $.fn.html = html;
if (children) $.fn.children = children;
if (remove) $.fn.remove = remove;
if (find) $.fn.find = find;
if (each) $.fn.each = each;
if (empty) $.fn.empty = empty;

const NodeType = {
  ELEMENT_NODE: 1,
  TEXT_NODE: 3,
  CDATA_SECTION_NODE: 4,
  PROCESSING_INSTRUCTION_NODE: 7,
  COMMENT_NODE: 8,
  DOCUMENT_NODE: 9,
  DOCUMENT_TYPE_NODE: 10,
  DOCUMENT_FRAGMENT_NODE: 11,
};

const PARSE_STYLE_HTML_FN_LIST = [];
const PRE_PARSE_HTML_CONF_LIST = [];
const PARSE_ELEM_HTML_CONF = {};
const REPLACE_SPACE_160_REG = new RegExp(String.fromCharCode(160), "g");
const TEXT_TAGS = [
  "span",
  "b",
  "strong",
  "i",
  "em",
  "s",
  "strike",
  "u",
  "font",
  "sub",
  "sup",
];
basicModules.forEach((module) => registerModule(module));
registerModule(wangEditorListModule);
registerModule(wangEditorTableModule);
registerModule(wangEditorVideoModule);
registerModule(wangEditorUploadImageModule);
registerModule(wangEditorCodeHighlightModule);
registerModule(markdownModule);
registerModule(formulaModule);

function parseElemHtml($elem, editor) {
  // pre-parse
  PRE_PARSE_HTML_CONF_LIST.forEach((conf) => {
    const { selector, preParseHtml } = conf;
    if ($elem[0].matches(selector)) {
      $elem = $(preParseHtml($elem[0]));
    }
  });

  const tagName = getTagName($elem);

  // <span> 判断有没有 data-w-e-type 属性。有则是 elem ，没有则是 text
  if (tagName === "span") {
    if ($elem.attr("data-w-e-type")) {
      return parseCommonElemHtml($elem, editor);
    } else {
      return parseTextElemHtml($elem, editor);
    }
  }

  // <code> 特殊处理
  if (tagName === "code") {
    const parentTagName = getTagName($elem.parent());
    if (parentTagName === "pre") {
      // <code> 在 <pre> 内，则是 elem
      return parseCommonElemHtml($elem, editor);
    } else {
      // <code> 不在 <pre> 内，则是 text
      return parseTextElemHtml($elem, editor);
    }
  }

  // 非 <code> ，正常处理
  if (TEXT_TAGS.includes(tagName)) {
    // text node
    return parseTextElemHtml($elem, editor);
  } else {
    // elem node
    return parseCommonElemHtml($elem, editor);
  }
}
function getTagName($elem) {
  if ($elem.length === 0) return "";
  const elem = $elem[0];
  if (elem.nodeType !== NodeType.ELEMENT_NODE) return "";
  return elem.tagName.toLowerCase();
}
function parseCommonElemHtml($elem, editor) {
  const children = genChildren($elem, editor);

  // parse
  const parser = getParser($elem);

  let parsedRes = parser($elem[0], children, editor);
  if (!Array.isArray(parsedRes)) parsedRes = [parsedRes]; // 临时处理为数组

  parsedRes.forEach((elem) => {
    const isVoid = Editor.isVoid(editor, elem);
    if (!isVoid) {
      // 非 void ，如果没有 children ，则取纯文本
      if (children.length === 0) {
        elem.children = [{ text: $elem.text().replace(/\s+/gm, " ") }];
      }

      // 处理 style
      PARSE_STYLE_HTML_FN_LIST.forEach((fn) => {
        elem = fn($elem[0], elem, editor);
      });
    }
  });
  return parsedRes;
}
function genChildren($elem, editor) {
  const children = [];

  // void node（ html 中编辑的，如 video 的 html 中会有 data-w-e-is-void 属性 ），不需要生成 children
  const isVoid = $elem.attr("data-w-e-is-void") != null;
  if (isVoid) {
    return children;
  }

  const childNodes = $elem[0].childNodes;

  // 处理空行（只有一个 child ，是 <br>）
  if (childNodes.length === 1) {
    if (childNodes[0].nodeName === "BR") {
      children.push({ text: "" });
      return children; // 直接返回
    }
  }

  // 遍历 DOM 子节点，生成 slate elem node children
  childNodes.forEach((child) => {
    if (child.nodeType === NodeType.ELEMENT_NODE) {
      // <br> ，则往 children 最后一个元素（如果是 text ）追加 `\n`
      if (child.nodeName === "BR") {
        // 尝试把 text 插入到最后一个 children
        const res = tryInsertTextToChildrenLastItem(children, "\n");
        if (!res) {
          // 若插入失败，则新建 item
          children.push({ text: "\n" });
        }
        return;
      }

      // 其他 elem
      const $child = $(child);
      const parsedRes = parseElemHtml($child, editor);
      if (Array.isArray(parsedRes)) {
        parsedRes.forEach((el) => children.push(el));
      } else {
        children.push(parsedRes);
      }
      return;
    }
    if (child.nodeType === NodeType.TEXT_NODE) {
      // text
      let text = child.textContent || "";
      if (text.trim() === "" && text.indexOf("\n") >= 0) {
        // 有换行，但无实际内容
        return;
      }

      if (text) {
        // 把 charCode 160 的空格（`&nbsp` 转换的），替换为 charCode 32 的空格（JS 默认的）
        text = replaceSpace160(text);

        // 尝试把 text 插入到最后一个 children
        const res = tryInsertTextToChildrenLastItem(children, text);
        if (!res) {
          // 若插入失败，则新建 item
          children.push({ text });
        }
      }
      return;
    }
  });
  return children;
}
function tryInsertTextToChildrenLastItem(children, str) {
  const len = children.length;
  if (len) {
    const lastItem = children[len - 1];
    if (Text.isText(lastItem)) {
      const keys = Object.keys(lastItem);
      if (keys.length === 1 && keys[0] === "text") {
        // lastItem 必须是纯文本，没有 marks
        lastItem.text = lastItem.text + str;
        return true;
      }
    }
  }
  return false;
}
function replaceSpace160(str) {
  const res = str.replace(REPLACE_SPACE_160_REG, " ");
  return res;
}
function deReplaceHtmlSpecialSymbols(str) {
  return str
    .replace(/&nbsp;/g, " ")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&reg;/g, "®")
    .replace(/&copy;/g, "©")
    .replace(/&trade;/g, "™")
    .replace(/&quot;/g, '"');
}

function parseTextElemHtml($text, editor) {
  if ($text.parents("pre").length === 0) {
    // 不在 <pre> 内部
    // 1. 替换无用空格、换行； 2. 将 <br> 替换为 `\n`
    $text[0].innerHTML = $text[0].innerHTML
      .replace(/\s+/gm, " ")
      .replace(/<br>/g, "\n");
  }

  // 用 textContent ，不能用 .text() 。后者无法识别 text 开头和末尾的 &nbsp;
  let text = $text[0].textContent || "";

  //【翻转】替换 html 特殊字符，如 &lt; 替换为 <
  text = deReplaceHtmlSpecialSymbols(text);

  // 把 charCode 160 的空格（`&nbsp` 转换的），替换为 charCode 32 的空格（JS 默认的）
  text = replaceSpace160(text);

  // 生成 text node
  let textNode = { text };

  // 处理 style
  PARSE_STYLE_HTML_FN_LIST.forEach((fn) => {
    textNode = fn($text[0], textNode, editor);
  });

  return textNode;
}
function htmlToContent(editor, html) {
  const res = [];

  // 空白内容
  if (html === "") html = "<p><br></p>";

  // 非 HTML 格式，文本格式，用 <p> 包裹
  if (html.indexOf("<") !== 0) {
    html = html
      .split(/\n/)
      .map((line) => `<p>${line}</p>`)
      .join("");
  }
  const $content = $(`<div>${html}</div>`);
  const list = Array.from($content.children());
  list.forEach((child) => {
    const $child = $(child);
    const parsedRes = parseElemHtml($child, editor);

    if (Array.isArray(parsedRes)) {
      parsedRes.forEach((el) => res.push(el));
    } else {
      res.push(parsedRes);
    }
  });

  return res;
}
function getParser($elem) {
  for (let selector in PARSE_ELEM_HTML_CONF) {
    if ($elem[0].matches(selector)) {
      return PARSE_ELEM_HTML_CONF[selector];
    }
  }
  return defaultParser;
}
function defaultParser(elem, children, editor) {
  return {
    type: "paragraph",
    children: [{ text: $(elem).text().replace(/\s+/gm, " ") }],
  };
}

function registerModule(module) {
  const {
    menus,
    renderElems,
    renderStyle,
    elemsToHtml,
    styleToHtml,
    preParseHtml,
    parseElemsHtml,
    parseStyleHtml,
    editorPlugin,
  } = module;

  // if (menus) {
  //   menus.forEach((menu) => Boot.registerMenu(menu));
  // }
  // if (renderElems) {
  //   renderElems.forEach((renderElemConf) =>
  //     Boot.registerRenderElem(renderElemConf)
  //   );
  // }
  // if (renderStyle) {
  //   Boot.registerRenderStyle(renderStyle);
  // }
  // if (elemsToHtml) {
  //   elemsToHtml.forEach((elemToHtmlConf) =>
  //     Boot.registerElemToHtml(elemToHtmlConf)
  //   );
  // }
  // if (styleToHtml) {
  //   Boot.registerStyleToHtml(styleToHtml);
  // }
  // if (preParseHtml) {
  //   preParseHtml.forEach((conf) => Boot.registerPreParseHtml(conf));
  // }
  if (parseElemsHtml) {
    parseElemsHtml.forEach((parseElemHtmlConf) =>
      registerParseElemHtmlConf(parseElemHtmlConf)
    );
  }
  if (parseStyleHtml) {
    PARSE_STYLE_HTML_FN_LIST.push(parseStyleHtml);
  }
  // if (editorPlugin) {
  //   Boot.registerPlugin(editorPlugin);
  // }
}
function registerParseElemHtmlConf(conf) {
  const { selector, parseElemHtml } = conf;
  PARSE_ELEM_HTML_CONF[selector] = parseElemHtml;
}
export { htmlToContent };
